<template>
  <div v-if="!item.hidden">
    <!-- 有子菜单的情况 -->
    <el-submenu
      v-if="hasChildren"
      :index="resolvePath"
      popper-append-to-body
      :popper-class="'sidebar-submenu'"
    >
      <template slot="title">
        <i :class="item.meta && item.meta.icon" class="menu-icon"></i>
        <span slot="title" class="menu-title">{{ item.meta && item.meta.title }}</span>
      </template>

      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath"
      />
    </el-submenu>

    <!-- 没有子菜单的情况 -->
    <el-menu-item v-else :index="resolvePath" :class="{ 'menu-item': true }">
      <i :class="item.meta && item.meta.icon" class="menu-icon"></i>
      <span slot="title" class="menu-title">{{ item.meta && item.meta.title }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0;
    },
    resolvePath() {
      if (this.hasChildren) {
        return this.basePath;
      }
      // 简单的路径拼接，替代 Node.js 的 path.resolve
      const base = this.basePath || "";
      const itemPath = this.item.path || "";

      if (!base) return itemPath;
      if (!itemPath) return base;

      // 确保路径以 / 开头，避免重复的 /
      const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
      const normalizedPath = itemPath.startsWith("/") ? itemPath : "/" + itemPath;

      return normalizedBase + normalizedPath;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-icon {
  margin-right: 8px;
  font-size: 16px;
  width: 16px;
  text-align: center;
}

.menu-title {
  font-size: 14px;
}

.menu-item {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    background-color: #409eff;
    transition: width 0.3s;
  }

  &:hover::before {
    width: 3px;
  }

  &.is-active::before {
    width: 3px;
  }
}
</style>
